import styled from 'styled-components';
import { btnReset } from '../../helpers/style-helpers';

export const ProgramTabsSC = styled.div`
  background: #fff;
`;
